





























































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { RawLocation } from 'vue-router';

import StarsBackground from 'frontend/views/premium/components/StarsBackground.vue';
import Button from 'frontend/components/Button.vue';
import { MobileGetter, Optional, User } from 'frontend/types';
import { GiftPlan } from 'frontend/types/premium/gifts';

@Component({
  components: {
    Button,
    StarsBackground,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('giftPlans', ['annualGiftPlan', 'lifetimeGiftPlan', 'oneMonthGiftPlan']),
    ...mapState('globals', ['user']),
  },
})
export default class GiftPlans extends Vue {
  private readonly isMobile!: MobileGetter;
  private readonly annualGiftPlan!: Optional<GiftPlan>;
  private readonly lifetimeGiftPlan!: Optional<GiftPlan>;
  private readonly annualAxId: string = 'clicked_premium_gift_paywall_button_year';
  private readonly lifetimeAxId: string = 'clicked_premium_gift_paywall_button_lifetime';
  private readonly monthAxId: string = 'clicked_premium_gift_paywall_button_month';
  private user!: User;

  private get annualLocation(): RawLocation {
    return this.giftFormLocation('annual');
  }

  private get lifetimeLocation(): RawLocation {
    return this.giftFormLocation('lifetime');
  }

  private get oneMonthLocation(): RawLocation {
    return this.giftFormLocation('month');
  }

  private giftFormLocation(planType: string): RawLocation {
    return {
      name: 'gift_purchase_message',
      params: { planType },
    };
  }

  private handleClick(nextLocation: RawLocation) {
    this.$router.push(nextLocation);
  }
}
